import { RotateCw, Maximize2, Droplet, Lock, LockOpen, Check } from 'lucide-react';
import { isLocked } from '../lib/model';

const Row = ({ icon, label, children, val, testid }) => (
  <div className="slider-row">
    <label>{icon}{label}</label>
    <div className="slider-ctrl">{children}</div>
    <span className="slider-val" data-testid={testid}>{val}</span>
  </div>
);

const norm = (d) => ((((d + 180) % 360) + 360) % 360) - 180;

export default function OverlayControls({ t, report, onChange, onConfirm, onUnlock, prefix = '' }) {
  const locked = isLocked(report);
  const a = norm(report.overlayAngle || 0);
  const adj = (d) => onChange({ overlayAngle: norm(a + d) });
  const id = (s) => `${prefix}${s}`;
  return (
    <div className={`ov-ctrl ${prefix ? 'ov-ctrl-fs' : ''}`} data-testid={id('overlay-controls-wrap')}>
      <fieldset className={`slider-box ${locked ? 'locked' : ''}`} disabled={locked} data-testid={id('overlay-controls')}>
        {locked && <div className="locked-hint" data-testid={id('locked-hint')}><Lock size={13} /> {t.lockedHint}</div>}
        <Row icon={<RotateCw size={14} />} label={t.lblRotate} val={`${a.toFixed(1)}°`} testid={id('angle-val')}>
          <button className="mini" data-testid={id('angle-minus-btn')} onClick={() => adj(-1)}>-1°</button>
          <input type="range" data-testid={id('angle-slider')} min="-180" max="180" step="0.5" value={a} onChange={(e) => onChange({ overlayAngle: +e.target.value })} />
          <button className="mini" data-testid={id('angle-plus-btn')} onClick={() => adj(1)}>+1°</button>
          <button className="mini" data-testid={id('angle-plus90-btn')} onClick={() => adj(90)}>+90°</button>
        </Row>
        <Row icon={<Maximize2 size={14} />} label={t.lblScale} val={`${report.overlayScale}%`} testid={id('scale-val')}>
          <input type="range" data-testid={id('scale-slider')} min="10" max="200" step="1" value={report.overlayScale} onChange={(e) => onChange({ overlayScale: +e.target.value })} />
        </Row>
        <Row icon={<Droplet size={14} />} label={t.lblOpacity} val={`${report.overlayOpacity}%`} testid={id('opacity-val')}>
          <input type="range" data-testid={id('opacity-slider')} min="0" max="100" step="1" value={report.overlayOpacity} onChange={(e) => onChange({ overlayOpacity: +e.target.value })} />
        </Row>
      </fieldset>
      {onConfirm && (locked
        ? <button className="btn btn-dark btn-sm" data-testid={id('unlock-btn')} onClick={onUnlock}><LockOpen size={14} /> {t.btnUnlock}</button>
        : <button className="btn btn-accent btn-sm pulse" data-testid={id('confirm-btn')} onClick={onConfirm}><Check size={14} /> {t.btnConfirmPos}</button>)}
    </div>
  );
}
